import { connect } from 'react-redux';
import { requestResetPassword } from '../../reducers/auth.reducers';
import ForgotPassword from './forgot-password';

const mapDispatchToProps = dispatch => ({
  requestPasswordReset: email => dispatch(requestResetPassword(email)),
});

const mapStateToProps = state => ({
  errorMessage: state.authentication.errorMessage,
  loading: state.authentication.loading,
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/app/login/forgot-password/forgot-password.container.js